import currencyService from '../service/currency.service';
import storeService from '../service/store.service';
import { handleError } from '../utils/notification.utils';

// Vue 2 compatible version (without ref/reactive)
export function useCurrency() {
  // Cache to prevent duplicate API calls
  let currencyCache = {
    currencies: null,
    store: null,
    lastFetch: null,
    isLoading: false
  };
  
  const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

  const isCacheValid = () => {
    const now = Date.now();
    return currencyCache.lastFetch && 
           (now - currencyCache.lastFetch) < CACHE_DURATION;
  };

  const retrieveCurrencyRates = async (forceRefresh = false) => {
    if (!forceRefresh && isCacheValid() && currencyCache.currencies) {
      return currencyCache.currencies;
    }

    if (currencyCache.isLoading) {
      // Wait for existing request to complete
      while (currencyCache.isLoading) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      return currencyCache.currencies || [];
    }

    currencyCache.isLoading = true;

    try {
      const response = await currencyService.findCurrencyRates(
        localStorage.getItem("mid"), 
        1, 
        100
      );
      
      const currencyRates = response.data.data;
      const currencies = [];

      if (currencyRates && currencyRates.length) {
        currencyRates.forEach(currencyRate => {
          const existCurrency = currencies.find(currency => currency === currencyRate.to);
          if (!existCurrency) {
            currencies.push(currencyRate.to);
          }
        });
      }

      currencyCache.currencies = currencies;
      currencyCache.lastFetch = Date.now();
      return currencies;
    } catch (error) {
      console.error('Error fetching currency rates:', error);
      if (error.response && ![401, 403, 409].includes(error.response.status)) {
        handleError(error);
      }
      return currencyCache.currencies || [];
    } finally {
      currencyCache.isLoading = false;
    }
  };

  const retrieveStore = async (forceRefresh = false) => {
    if (!forceRefresh && isCacheValid() && currencyCache.store) {
      return currencyCache.store;
    }

    try {
      const response = await storeService.findById(
        localStorage.getItem("mid"), 
        localStorage.getItem("mid")
      );
      currencyCache.store = response.data.data;
      return currencyCache.store;
    } catch (error) {
      console.error('Error fetching store:', error);
      handleError(error);
      return currencyCache.store || {};
    }
  };

  const initializeCurrencies = async (forceRefresh = false) => {
    const [store, currencies] = await Promise.all([
      retrieveStore(forceRefresh),
      retrieveCurrencyRates(forceRefresh)
    ]);

    return { store, currencies };
  };

    const setDefaultCurrency = (component, currency) => {
    // Helper function to set default currency based on component structure
    if (component.selectedCurrency !== undefined) {
        component.selectedCurrency = currency;
    } else if (
        component.formData !== undefined &&
        component.formData.currency !== undefined
    ) {
        component.formData.currency = currency;
    } else if (
        component.filters !== undefined &&
        component.filters.currency !== undefined
    ) {
        component.filters.currency = currency;
    }
    };

  const clearCache = () => {
    currencyCache = {
      currencies: null,
      store: null,
      lastFetch: null,
      isLoading: false
    };
  };

  return {
    retrieveCurrencyRates,
    retrieveStore,
    initializeCurrencies,
    setDefaultCurrency,
    clearCache
  };
}


// WEBPACK FOOTER //
// ./src/composables/useCurrency.js